import { useBlockProps, RichText } from '@wordpress/block-editor';
import { getIconClasses, resolvePresetValue } from '../../utils/helpers';

export default function Save({ attributes }) {
  const { iconName, iconType, text, iconColor } = attributes;

  /*
   * Written only when set. An item that never had an icon colour saves exactly
   * the markup it saved before this attribute existed, so adding it did not
   * invalidate a single line of existing content.
   */
  const blockProps = useBlockProps.save({
    className: 'brandy-icon-list__item',
    /*
     * A palette pick is stored as `var:preset|color|<slug>`, a reference the
     * browser cannot read, so it is expanded on the way into the markup. An
     * item saved before presets holds a plain hex, which passes through
     * untouched — the saved output is byte-identical for it, so no existing
     * content is invalidated.
     */
    ...(iconColor
      ? {
          style: {
            '--brandy-icon-list-icon-color': resolvePresetValue(iconColor),
          },
        }
      : {}),
  });

  const iconClasses = getIconClasses(iconName, iconType);

  return (
    <li {...blockProps}>
      {iconClasses && <i className={iconClasses} aria-hidden="true" />}
      <RichText.Content
        tagName="span"
        className="brandy-icon-list__text"
        value={text}
      />
    </li>
  );
}
